import React, { useContext, useMemo } from 'react';
import { AppContext } from '../../../../../../../contexts/AppContext';

export default function useProductSkus() {
  const { state } = useContext(AppContext);
  const { contentData } = state;

  return useMemo(() => {
    return contentData.skus.map((sku) => sku.partnumber);
  }, [contentData.skus]);
}
